import { render, staticRenderFns } from "./lessonDetail.vue?vue&type=template&id=b2a0612a&scoped=true"
import script from "./lessonDetail.vue?vue&type=script&lang=js"
export * from "./lessonDetail.vue?vue&type=script&lang=js"
import style0 from "./lessonDetail.vue?vue&type=style&index=0&id=b2a0612a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a0612a",
  null
  
)

export default component.exports